export interface BreakoutConfigureOptions {
  automaticallyMoveParticipantsIntoRooms: boolean;
  allowParticipantsReturnToMainSession: boolean;
  allowParticipantsChooseRoom: boolean;
  automaticallyMoveParticipantsIntoMainRoom: boolean;
  closeAfter: number;
  countDown: number;
}

/** Whatever carries this event's organiser-chosen breakout timing — LiteContext or EventContext (VE-028). */
export interface BreakoutTimingSource {
  breakout_close_after_minutes: number;
  breakout_countdown_seconds: number;
}

/**
 * Builds the configureBreakoutRooms payload. closeAfter/countDown always come
 * from the organiser-chosen values on this event's config — Lite's plan or a
 * full event's VirtualEventProviderConfig (VE-028) — never left unset: an
 * unset field would inherit whatever the host last left ticked in Zoom's own
 * breakout panel (e.g. a stale 30-minute auto-close), not "off".
 */
export function buildBreakoutConfig(source: BreakoutTimingSource | null): BreakoutConfigureOptions {
  return {
    automaticallyMoveParticipantsIntoRooms: true,
    allowParticipantsReturnToMainSession: true,
    // Hoogah owns placement; letting attendees pick defeats the assignment plan.
    allowParticipantsChooseRoom: false,
    // Suppresses Zoom's consent dialog when the app moves people back to main.
    // Needs desktop client 5.13.10+; older clients ignore the flag harmlessly.
    automaticallyMoveParticipantsIntoMainRoom: true,
    closeAfter: source?.breakout_close_after_minutes ?? 0,
    countDown: source?.breakout_countdown_seconds ?? 0,
  };
}
